module.exports = __webpack_public_path__ + "static/media/25.20385ac7.jpeg";